import uuid from "@/shared/uuid";

const nodaMixin = {
  created() {
    this.nodaPay = {
      url: process.env.VUE_APP_NODA_PAY_URL,
      apiKey: process.env.VUE_APP_NODA_PAY_KEY,
      currency: this.currency.toLocaleLowerCase(),
      amount: this.amount / 100,
      returnUrl: `${process.env.VUE_APP_BASE_URL}/#/receipt`,
      webhookUrl: `${process.env.VUE_APP_BASE_API_URL}/api/v1/webhook-noda`,
      description: this.description,
      customerId: this.$cookie.get("userIdentifier"),
      paymentId: uuid(),
    };
  },
  data() {
    return {
      formType: "checkout_form",
      methodType: "Noda Credit Card",
      fullScreenLoading: false,
      nodaPay: {
        disabled: false,
      },
    };
  },
  methods: {
    async pay() {
      this.fullScreenLoading = true;
      this.$amplitude.logEvent(
        `Payment page event ${this.methodType} button clicked`,
        {
          qrCode: this.$route.params.qrCode ?? this.$route.params.qrCodes,
        }
      );

      await this.$axios
        .post("/api/v1/tx-noda", {
          clientPaysFee: !!this.clientPaysFee,
          qrCodes: this.paymentObject,
          amount: Number((this.nodaPay.amount * 100).toFixed(0)),
          currency: this.currency,
          payData: JSON.stringify({
            paymentId: this.nodaPay.paymentId,
          }),
          payerEmail: "",
        })
        .then((response) => {
          if (response?.data?.payload) {
            this.$cookie.delete("txId");
            this.$cookie.set("txId", response.data.payload.txId);
          }
        });

      try {
        const response = await fetch(this.nodaPay.url, {
          method: "POST",
          headers: {
            Accept: "application/json, text/json, text/plain",
            "Content-Type": "application/*+json",
            "x-api-key": this.nodaPay.apiKey,
          },
          body: JSON.stringify({
            amount: this.nodaPay.amount,
            currency: this.nodaPay.currency,
            customerId: this.nodaPay.customerId,
            paymentId: this.nodaPay.paymentId,
            description: this.nodaPay.description,
            returnUrl: this.nodaPay.returnUrl,
            webhookUrl: this.nodaPay.webhookUrl,
            card: {
              type: this.formType,
            },
          }),
        });

        const data = await response.json();
        if (data?.url) {
          this.fullScreenLoading = false;
          window.open(data?.url, "_self");
        }
      } catch (error) {
        this.fullScreenLoading = false;
        console.error(error);
      }
    },
  },
  watch: {
    amount(value) {
      this.nodaPay.amount = value / 100;
    },
  },
};

export default nodaMixin;
